<template>
  <ValidationProvider
    :vid="checkboxId"
    :rules="rules"
    :name="checkboxId"
    class="form-group checkbox-form"
    tag="div"
    v-slot="{ invalid, errors }"
    :ref="checkboxId"
  >
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-2 ">
          <input
            v-bind:class="{ 'error-shadow': errors.length > 0 }"
            class="pull-right "
            :id="checkboxId"
            :name="checkboxId"
            v-model="val"
            :title="tooltip"
            :disabled="!enabled"
            :type="type"
          />
        </div>
        <div class="col-sm-10 ">
          <label :for="checkboxId" class="pull-left">
            <span class="text-danger" v-if="required">*</span>
            <span class="text-danger" v-if="errors.length > 0">{{
              description
            }}</span>
            <span v-if="errors.length == 0">{{ description }}</span>
          </label>
        </div>
      </div>
    </div>
  </ValidationProvider>
</template>

<script>
import Vue from "vue";
import {
  Validator,
  ValidationProvider,
} from "vee-validate/dist/vee-validate.esm";
import { Instance as FormValidationService } from "../../services/FormValidationRuleService.ts";

export default Vue.extend({
  name: "checkbox-field",
  components: {
    ValidationProvider,
  },
  created() {
    if (this.required) {
      Validator.extend(
        "requiredCheckbox",
        FormValidationService.requiredCheckbox()
      );
    }
  },
  props: {
    checkboxId: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    tooltip: String,
    description: String,
    required: {
      type: Boolean,
      default: false,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: "text",
    },
    customRules: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  computed: {
    rules() {
      const rules = {};
      if (this.required) {
        rules["requiredCheckbox"] = true;
      }
      if (this.computedPattern) {
        rules["regex"] = this.computedPattern;
      }
      return { ...rules, ...this.customRules };
    },
    computedPattern() {
      if (!this.pattern) {
        return null;
      }
      return this.pattern;
    },
    val: {
      // getter
      get: function() {
        return this.value;
      },
      // setter
      set: function(newVal) {
        this.$emit("input", newVal);
      },
    },
  },
});
</script>

<style scoped>
.justify-center {
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  float: none;
}
.label-align-left {
  text-align: left;
}
.checkbox-marg {
  margin-right: -2px;
}
.error-shadow {
  border-radius: 0.2rem;
  box-shadow: 0 0 0.2rem 0.2rem red;
}
</style>
